(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["header-menu-feature"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ironsideMenuCtaTracking) return;
    window.ironsideMenuCtaTracking = true;
    const seen = new Set();
    const send = (eventName, a) => {
      const location = a.closest('.ironside-mnav-extras') ? 'menu_mobile' : 'menu_desktop';
      const promo = {
        promotion_id: a.dataset.promotionId,
        promotion_name: 'Menú · ' + a.dataset.name,
        creative_name: a.dataset.name,
        creative_slot: location + '_1',
        location_id: location
      };
      const payload = Object.assign({}, promo, {
        items: [Object.assign({ item_id: 'cta_' + a.dataset.promotionId.toLowerCase(), item_name: a.dataset.name }, promo)]
      });
      try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-ironside-menu-cta]');
      if (a) send('select_promotion', a);
    });
    if (!('IntersectionObserver' in window)) return;
    // La tarjeta se repite en cada panel; se cuenta una vista por contexto (desktop / mobile).
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const key = en.target.closest('.ironside-mnav-extras') ? 'mobile' : 'desktop';
        if (!seen.has(key)) { seen.add(key); send('view_promotion', en.target); }
      });
    }, { threshold: 0.5 });
    const watch = () => document.querySelectorAll('[data-ironside-menu-cta]').forEach((a) => observer.observe(a));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  })();
  } catch(e) { console.error(e); }
})();

})();
